const o = "grey", t = "green", e = "blue", n = "yellow", s = [o, t, e, n];
export {
  s as tagColors
};
